<template>
    <f7-page class="page-password-level2">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>ĐỔI MẬT KHẨU CẤP 2</f7-nav-title>
        </f7-navbar>
        <f7-row v-if="_.isEmpty(user_info.telegram)">
            <f7-col>
                <f7-card>
                    <f7-card-content>
                        <p>Vui lòng liên kết Telegram trước</p>
                    </f7-card-content>
                    <f7-card-footer>
                        <f7-link @click="$f7router.navigate('/tao-ma-gioi-thieu')">Liên kết ngay</f7-link>
                    </f7-card-footer>
                </f7-card>
            </f7-col>
        </f7-row>
        <template v-else>
            <f7-list inset>
                <f7-list-input
                    type="password"
                    placeholder="MK cấp 1"
                    :value="form_password.login_password"
                    @input="form_password.login_password = $event.target.value"
                >
                    <f7-icon slot="media" ios="f7:person"></f7-icon>
                </f7-list-input>
                <f7-list-input
                    type="password"
                    placeholder="MK cấp 2"
                    info="Để rỗng nếu đây là lần khởi tạo đầu tiên"
                    :value="form_password.old_password"
                    @input="form_password.old_password = $event.target.value"
                >
                    <f7-icon slot="media" ios="f7:person"></f7-icon>
                </f7-list-input>
                <f7-list-input
                    placeholder="MK cấp 2 mới"
                    type="password"
                    :value="form_password.new_password"
                    @input="form_password.new_password = $event.target.value"
                >
                    <f7-icon slot="media" ios="f7:lock"></f7-icon>
                </f7-list-input>
                <f7-list-input
                    placeholder="Nhập lại MK mới"
                    type="password"
                    :value="form_password.new_password_confirmation"
                    @input="form_password.new_password_confirmation = $event.target.value"
                >
                    <f7-icon slot="media" ios="f7:lock"></f7-icon>
                </f7-list-input>
                <f7-list-input
                    placeholder="Mã OTP"
                    type="text"
                    :value="form_password.otp"
                    @input="form_password.otp = $event.target.value"
                >
                    <f7-icon slot="media" ios="f7:qrcode"></f7-icon>
                    <template slot="content-end">
                        <f7-button class="button-otp" outline @click.prevent="generateOTP">Lấy mã</f7-button>
                    </template>
                </f7-list-input>
            </f7-list>
            <f7-block inset class="mt-1">
                <f7-button fill color="primary" @click.prevent="submitChangePasswordLevel2">ĐỔI MK CẤP 2</f7-button>
            </f7-block>
        </template>
    </f7-page>
</template>
<style scoped>
.button-otp {
    width : 110px;
}
</style>
<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState(['user_info'])
    },
    data() {
        return {
            form_password: {
                login_password: '',
                old_password: '',
                new_password: '',
                new_password_confirmation: '',
                otp: ''
            }
        }
    },
    methods: {
        submitChangePasswordLevel2() {
            this.$f7.dialog.preloader();

            this.$store.dispatch('changePasswordLevel2', this.form_password).then(() => {
                return this.$store.dispatch('getMe');
            }).then(() => {
                this.$f7.dialog.close();
                this.$f7.dialog.alert('Đổi mật khẩu cấp 2 thành công', 'SUCCESS!');
            }).catch((err) => {
                this.$f7.dialog.close();
                this.$f7.dialog.alert(err, 'LỖI!');
            });
        },
        generateOTP() {
            this.$f7.dialog.preloader();

            this.$store.dispatch('generateOTPchangePasswordLevel2', this.form_password).then(() => {
                this.$f7.dialog.close();
            }).catch((err) => {
                this.$f7.dialog.close();
                this.$f7.dialog.alert(err, 'LỖI!');
            });
        }
    }
};
</script>
